<template>
  <b-card
    class="current-plan-product-card"
    body-class="current-plan-subcard-body-class"
    :style="'border: 3px solid ' + productColor()"
  >
    <div><b>Current Plan</b></div>
    <div>
      <div v-if="activeproduct == null">
        <span v-if="account.flexiplan == null || account.flexiplan.credits < 1">This account does not have a current plan.<br/></span>
        <span v-if="account.flexiplan != null && account.flexiplan.credits > 0">You have {{ account.flexiplan.credits }} credits but no current plan.<br/></span>
        <span v-if="account.flexiplan != null && account.flexiplan.credits > 0">Click <b-button class="p-0 mt-n1" variant="link" @click="startDayAccess">here</b-button> to start access.</span>
      </div>
      <div v-else>
        <span
          >You are currently on the
          <strong :style="'color: ' + productColor()">{{
            activeproduct.name
          }}</strong
          > plan.<br
        /></span>
        <span v-if="activeuntil != null && datediff != null"
          >This lasts {{ datediff }} {{ datediff === 1 ? 'day' : 'days' }} until
          {{
            $options.filters.dateFormat(
              new Date(activeuntil),
              "dddd, MMM D YYYY"
            )
          }}.<br
        /></span>
        <span v-if="account.flexiplan != null && account.flexiplan.credits > 0">You also have {{ account.flexiplan.credits }} credits which will then be used.</span>
      </div>
    </div>
  </b-card>
</template>

<script>
import store from '@/store';
import { mapGetters } from 'vuex';
export default {
  name: "CurrentPlanDetails",
  props: {
    datediff: {
        type: Number,
        default: undefined
    }
  },
  computed: {
    ...mapGetters({
      products: "pricing/getProducts",
      subscription: "plan/getSubscription",
      activeproduct: "plan/getActiveProduct",
      activeuntil: "plan/getActiveUntil",
      account: "account/account",
    }),
  },
  methods: {
    productColor() {
      if (this.subscription != null) {
        switch (this.subscription.product.productid) {
          case 1:
            return "#38AADE";
          case 2:
            return "#EE811A";
          case 3:
            return "#5DB12F";
          default:
            return "#471747";
        }
      } else if (this.account.flexiplan != null) {
        switch (this.account.flexiplan.product.productid) {
          case 1:
            return "#38AADE";
          case 2:
            return "#EE811A";
          case 3:
            return "#5DB12F";
          default:
            return "#471747";
        }
      } else if (this.activeproduct != null) {
        switch (this.activeproduct.productid) {
          case 1:
            return "#38AADE";
          case 2:
            return "#EE811A";
          case 3:
            return "#5DB12F";
          default:
            return "#471747";
        }
      } else return "#471747";
    },
    startDayAccess() {
      let credits = this.account.flexiplan.credits >= this.account.flexiplan.product.credits ? this.account.flexiplan.product.credits : this.account.flexiplan.credits
      let productid = this.products.find((product) => product.credits === credits).productid
      this.$portalapi.get('flexiplan/day', { params: { productid: productid, credits: credits } } )
      .then((response) => {
        store.dispatch("plan/initialiseSubscription");
        store.dispatch("event/initialiseEventtype");
        window.location.reload();
      }).catch((error) => {
        this.$log.onError(error.data);
        alert('Failed to start FlexiPlan access. Please buy credits if you have less than the required amount or contact SoldierNET.');
      })
    }
  },
};
</script>

<style lang="scss">

.current-plan-subcard-body-class {
  padding: 0.6rem !important;
}

.current-plan-product-card {
  border-radius: 16px 16px 16px 16px;
  margin-bottom: 0.5rem !important;
  width: fit-content;
  margin: auto;
  text-align: center;
}

</style>